export default __webpack_public_path__ + "static/media/congrats-icon@3x.35e0caef.png";